import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { userDTO } from "../../types/types"
type LatestCountryDTO = {
    lastCountry:string
};

type LatestCountryResponse  = userDTO & ApiError;

export const UpdateLatestCountry = (data: LatestCountryDTO): Promise<LatestCountryResponse> => {
    return axios.patch(`/student/updateByToken`, data)
        .then(response => response.data as LatestCountryResponse);
};